const ThoughtfulOffreing = [
    {
        title: 'Fabulous face Cleaner',
        img: 'https://i.ibb.co/XYZcF2D/Aesop-Skin-Fabulous-Face-Cleanser-100m-L-large.png',
        text:'For skin clearing, Gentle Custing'
    },
    {
        title: 'Parsely ceddy facial cleaner',
        img: 'https://i.ibb.co/J7hpnpw/Aesop-Skin-Parsley-Seed-Facial-Cleanser-100m-L-large.png',
        text:'Ideal for city dwellera'
    },
    {
        title: 'Granium leaf body cleanser',
        img: 'https://i.ibb.co/zbP4jMs/Aesop-Body-Geranium-Leaf-Body-Cleanser-100m-L-Hybris-Large-835x962px.png',
        text:'A gentle innovation gel cleaner'
    },
    {
        title: 'Recursion aromatic hand wash',
        img: 'https://i.ibb.co/Q9MZHVn/Aesop-Hand-Resurrection-Aromatique-Hand-Wash-500m-L-large.png',
        text:'Gentle cleansinging for hard-working'
    },
]

export default ThoughtfulOffreing;